var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportDiscoveryTaskEnv_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import '@symon-ai/wisepipe-common-connection'; // force import for JsonSchemaV2
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { importDiscoveryTaskEnvSchemaValidation } from '../validations.generated';
export const importDiscoveryTaskEnvSchema = {
    $id: 'urn:wisepipe-common-data:ImportDiscoveryTaskEnv',
    type: 'object',
    properties: {
        stage: { type: 'string', minLength: 1 },
        apiUrl: { type: 'string', format: 'uri' },
        s3DataBucket: { type: 'string', minLength: 1 },
        googleClientIDParam: { type: 'string', minLength: 1 },
        googleClientSecretParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientIDParam: { type: 'string', minLength: 1 },
        googleSheetsImportClientSecretParam: { type: 'string', minLength: 1 },
        googleAdWordsDevTokenParam: { type: 'string', minLength: 1 },
        salesforceClientIDParam: { type: 'string', minLength: 1 },
        salesforceClientSecretParam: { type: 'string', minLength: 1 },
        hubspotClientIDParam: { type: 'string', minLength: 1 },
        hubspotClientSecretParam: { type: 'string', minLength: 1 },
        dynamicsClientIDParam: { type: 'string', minLength: 1 },
        dynamicsClientSecretParam: { type: 'string', minLength: 1 },
        onedriveClientIDParam: { type: 'string', minLength: 1 },
        onedriveClientSecretParam: { type: 'string', minLength: 1 },
        encryptionSecretName: { type: 'string', minLength: 1 },
        connection: { $ref: 'urn:wisepipe-common-connection:Connection' },
        credentials: { $ref: 'urn:wisepipe-common:Credentials' }
    },
    required: [
        'stage',
        'apiUrl',
        's3DataBucket',
        'googleClientIDParam',
        'googleClientSecretParam',
        'googleSheetsImportClientIDParam',
        'googleSheetsImportClientSecretParam',
        'googleAdWordsDevTokenParam',
        'salesforceClientIDParam',
        'salesforceClientSecretParam',
        'hubspotClientIDParam',
        'hubspotClientSecretParam',
        'dynamicsClientIDParam',
        'dynamicsClientSecretParam'
    ]
};
let ImportDiscoveryTaskEnv = ImportDiscoveryTaskEnv_1 = class ImportDiscoveryTaskEnv {
    constructor(stage, apiUrl, s3DataBucket, googleClientIDParam, googleClientSecretParam, googleSheetsImportClientIDParam, googleSheetsImportClientSecretParam, googleAdWordsDevTokenParam, salesforceClientIDParam, salesforceClientSecretParam, hubspotClientIDParam, hubspotClientSecretParam, dynamicsClientIDParam, dynamicsClientSecretParam, onedriveClientIDParam, onedriveClientSecretParam, connection, credentials, encryptionSecretName) {
        this.hubspotClientIDParam = hubspotClientIDParam;
        this.hubspotClientSecretParam = hubspotClientSecretParam;
        this.dynamicsClientIDParam = dynamicsClientIDParam;
        this.dynamicsClientSecretParam = dynamicsClientSecretParam;
        this.onedriveClientIDParam = onedriveClientIDParam;
        this.onedriveClientSecretParam = onedriveClientSecretParam;
        this.stage = stage;
        this.apiUrl = apiUrl;
        this.s3DataBucket = s3DataBucket;
        this.googleClientIDParam = googleClientIDParam;
        this.googleClientSecretParam = googleClientSecretParam;
        this.googleSheetsImportClientIDParam = googleSheetsImportClientIDParam;
        this.googleSheetsImportClientSecretParam = googleSheetsImportClientSecretParam;
        this.googleAdWordsDevTokenParam = googleAdWordsDevTokenParam;
        this.salesforceClientIDParam = salesforceClientIDParam;
        this.salesforceClientSecretParam = salesforceClientSecretParam;
        this.connection = connection;
        this.credentials = credentials;
        this.encryptionSecretName = encryptionSecretName;
        JSON.validate(this, ImportDiscoveryTaskEnv_1);
    }
};
ImportDiscoveryTaskEnv = ImportDiscoveryTaskEnv_1 = __decorate([
    JsonSchemaV2(importDiscoveryTaskEnvSchema, importDiscoveryTaskEnvSchemaValidation)
], ImportDiscoveryTaskEnv);
export { ImportDiscoveryTaskEnv };
//# sourceMappingURL=importDiscoveryTaskEnv.js.map